import React from "react";
import { Monster } from "../types";
import { style } from "../style";
import WindowPanel from "./WindowPanel";
import TitleSquare from "./TitleSquare";


export default function MonsterCard(props: Monster)
{
    return (
        <section className={style.panel + " " + style.panelBorder + " gap-8"} >
            <h3 className={style.h3Tall} >
                <TitleSquare tall={true} />
                <div>
                    <div className="text-sm uppercase">{props.category}</div>
                    <div className="capitalize">{props.name}</div>
                </div>
            </h3 >
            <div className={style.panelGroup}>
                {/* Info area */}
                <WindowPanel
                    title="info"
                    contentGrid={
                        <div className={style.infoGroup}>
                            <div className={style.infoLabel}>Stage</div>
                            <div className={style.infoSubLabel}>{props.stage}</div>
                            <div className={style.infoLabel}>Type</div>
                            <div className={style.infoSubLabel}>{props.type}</div>
                            <div className={style.infoLabel}>Origin</div>
                            <div className={style.infoSubLabel}>{props.origin}</div>
                            <div className={style.infoLabel}>Location</div>
                            <div className={style.infoSubLabel}>{props.location}</div>
                        </div>
                    }
                    addedClassGroup=" flex-1"
                />
                {/* Portrait */}
                <WindowPanel
                    title="portrait"
                    imagePath={props.image}
                    addedClassGroup=" flex-1"
                />
            </div>
            <div className="mb-6 md:mb-8 mx-4">
                <WindowPanel
                    title="Description"
                    contentText={props.description}
                />
            </div>
        </section >
    );
}